export const manufacturingProcesses = [
  {
    id: 1,
    name: 'RAW MATERIAL & WIRE PROCESSING',
    description: 'Premium-grade steel from JSW & JSPL, fully inspected for chemical, metallurgical, and mechanical properties before wire drawing.',
    image: '/manufacturing/rm-1.png',
    pages: [
      {
        title: 'Inspection and Spectro Analysis',
        image: '/manufacturing/rm-1.png',
        content: [
          'XPS ensures the use of premium-grade raw materials to maintain consistent product quality.',
          'XPS sources high-quality steel from reputed manufacturers like JSW and JSPL.',
          'Each incoming lot undergoes strict inspection using a spectrometer to verify chemical composition.',
          'Spectrometer analysis ensures the exact percentage of elements meets required standards.'
        ]
      },
      {
        title: 'Mechanical and Structural Properties',
        image: '/manufacturing/rm-2.png',
        content: [
          'Metallurgical properties are verified to ensure structural integrity and performance.',
          'Mechanical properties such as tensile strength and hardness are also carefully evaluated.',
          'Every batch is tagged with a unique heat number for complete traceability.',
          'Strict documentation is maintained for all inspection and testing processes.'
        ]
      },
      {
        title: 'Wire Drawing and Dimensional Accuracy',
        image: '/manufacturing/rm-3.png',
        content: [
          'Approved raw materials are then processed for further manufacturing stages.',
          'Wire drawing is carried out to achieve the precise wire size required for cold forging.',
          'Advanced machinery ensures uniformity and dimensional accuracy in wire processing.',
          'All records are systematically maintained and are available on demand for quality assurance and audits.'
        ]
      }
    ]
  },
  {
    id: 2,
    name: 'COLD FORGING',
    description: 'Metal shaped at room temperature on fully automatic, high-speed multi-station bolt formers for fasteners M3 to M27.',
    image: '/manufacturing/cf-1.jpg',
    pages: [
      {
        title: 'Process of Cold Forging',
        image: '/manufacturing/cf-1.jpg',
        content: [
          'XPS utilizes advanced cold forging technology for the efficient production of high-strength fasteners.',
          'Cold Forging shapes metal at room temperature using external compressive forces on fully automatic, high-speed multi-station bolt formers.',
          'This process enhances grain flow, resulting in superior strength and durability of the components.',
          'It ensures excellent dimensional accuracy and consistency across high-volume production.'
        ]
      },
      {
        title: 'Mechanical Aspects of Cold Forging',
        image: '/manufacturing/cf-2.png',
        content: [
          'Cold forging also delivers a smooth surface finish, minimizing the need for additional machining.',
          'XPS produces a wide range of high-tensile fasteners (M3 to M27) through cold forging.',
          'For sizes above M27, hot forging is employed to meet specific manufacturing requirements.',
          'Multi-station bolt formers enable complex shapes to be formed in a single continuous process.'
        ]
      },
      {
        title: 'Tools, Dies, and Quality Assurance',
        image: '/manufacturing/cf-3.png',
        content: [
          'The process is highly efficient, reducing material wastage and improving productivity.',
          'Continuous in-process quality checks ensure defect-free components.',
          'Advanced tooling and die design contribute to precision and repeatability.',
          'Cold forging at XPS ensures consistent quality, high performance, and reliability in every fastener produced.'
        ]
      }
    ]
  },
  {
    id: 3,
    name: 'HOT FORGING',
    description: 'Metal heated by high-speed electric induction and pressed into dies — ideal for large diameter fasteners M27 and above.',
    image: '/manufacturing/hf-1.png',
    pages: [
      {
        title: 'Process of Hot Forging',
        image: '/manufacturing/hf-1.png',
        content: [
          'XPS employs advanced hot forging processes for manufacturing large and specialized fasteners.',
          'Hot Forging shapes metal by heating it to the proper temperature using high-speed electric induction before pressing it into a die.',
          'This process enhances the material’s malleability, allowing it to be formed into complex shapes.',
          'It is ideal for larger diameter fasteners (M27 and above) that are not suitable for cold forging.'
        ]
      },
      {
        title: 'Mechanical Properties of Hot Forging',
        image: '/manufacturing/hf-2.png',
        content: [
          'Hot forging ensures improved structural integrity and strength in heavy-duty applications.',
          'The process allows efficient forming of high-volume and large-sized components.',
          'XPS has the capability to forge highly specialized parts such as bolts, screws, and studs.',
          'In addition to custom parts, XPS also manufactures a standard range of large fasteners.'
        ]
      },
      {
        title: 'Equipment Accuracy and Quality Assurance',
        image: '/manufacturing/hf-3.png',
        content: [
          'Precise temperature control ensures uniform material properties throughout the component.',
          'Advanced forging equipment ensures accuracy and repeatability in production.',
          'Strict quality checks are conducted during and after the forging process.',
          'Hot forging at XPS guarantees reliable performance and durability for demanding industrial applications.'
        ]
      }
    ]
  },
  {
    id: 4,
    name: 'SECONDARY OPERATIONS',
    description: 'In-house CNC machining, drilling, boring, grinding, slotting, and milling for complete control over special fastener requirements.',
    image: '/manufacturing/sec-1.png',
    pages: [
      {
        title: 'CNC Operations',
        image: '/manufacturing/sec-1.png',
        content: [
          'XPS offers comprehensive secondary operations to meet diverse and complex fastener requirements.',
          'XPS is capable of performing many secondary operations in-house, including CNC machining, drilling, boring, grinding, slotting, and milling — enabling complete control over special and custom fastener requirements.',
          'In-house capabilities ensure better coordination, faster turnaround times, and consistent quality.',
          'CNC machining enables high precision and tight tolerances for critical components.'
        ]
      },
      {
        title: 'Drilling, Slotting, and Milling',
        image: '/manufacturing/sec-2.jpg',
        content: [
          'Drilling and boring operations are carried out for accurate hole dimensions and alignment.',
          'Slotting operations allow the creation of keyways, grooves, and internal features with precision.',
          'Milling operations enable the formation of complex geometries and custom profiles.',
          'Continuous inspection during secondary operations maintains strict quality standards.'
        ]
      },
      {
        title: 'Grinding, Efficiency, and Precision',
        image: '/manufacturing/sec-3.png',
        content: [
          'Grinding processes enhance surface finish and dimensional accuracy.',
          'Advanced equipment and skilled operators ensure repeatability and efficiency.',
          'The integrated approach minimizes dependency on external vendors and reduces lead times.',
          'Secondary operations at XPS ensure flexibility, precision, and complete customization for every project.'
        ]
      }
    ]
  },
  {
    id: 5,
    name: 'HEAT TREATMENT',
    description: 'SCADA-controlled continuous furnace achieves 90% martensite grain structure at the core for high-tensile strength.',
    image: '/manufacturing/ht-new-1.png',
    pages: [
      {
        title: 'Fastener Strength and Hardness',
        image: '/manufacturing/ht-new-1.png',
        content: [
          'XPS ensures superior fastener performance through precise and controlled heat treatment processes.',
          'Heat Treatment is conducted to ensure fasteners meet the required strength and hardness class.',
          'XPS uses a state-of-the-art continuous furnace to achieve consistent and uniform results.',
          'The heat treatment furnace is SCADA controlled, ensuring accurate monitoring and process control.'
        ]
      },
      {
        title: 'Mechanical and Structural Aspects of Heat Treatment',
        image: '/manufacturing/ht-new-2.png',
        content: [
          'Precise temperature regulation ensures optimal metallurgical transformation of the material.',
          'The process attains a minimum of 90% martensite grain structure at the core — a key quality indicator for high-tensile fasteners.',
          'Controlled heating and quenching enhance strength, toughness, and wear resistance.',
          'Uniform heat distribution ensures consistent properties across all components.'
        ]
      },
      {
        title: 'Quality Checks and Documentation',
        image: '/manufacturing/ht-new-3.png',
        content: [
          'Continuous monitoring minimizes variations and ensures repeatability in production.',
          'Strict quality checks are conducted after heat treatment to verify hardness and microstructure.',
          'All heat treatment data is recorded and available on demand for traceability and audits.',
          'Heat treatment at XPS guarantees high strength, reliability, and compliance with industry standards.'
        ]
      }
    ]
  },
  {
    id: 6,
    name: 'SURFACE TREATMENT',
    description: 'Automatic plating and phosphating lines with finishes from zinc plating to Geomet, Dacromet, and Delta Seal.',
    image: '/manufacturing/sf-1.png',
    pages: [
      {
        title: 'Fastener Protection',
        image: '/manufacturing/sf-1.png',
        content: [
          'XPS ensures superior durability and appearance through advanced surface finishing processes.',
          'Surface finishing protects fasteners from corrosion and improves aesthetics.',
          'XPS offers a wide range of treatments on automatic plating and phosphating lines.',
          'Zinc and manganese phosphate coatings enhance corrosion resistance and provide a good base for lubrication.'
        ]
      },
      {
        title: 'Zinc Plating, Nickel Plating, Chrome Passivation',
        image: '/manufacturing/sf-2.png',
        content: [
          'Alkaline zinc plating is available in multiple finishes including white, blue, yellow, olive green, and black passivation.',
          'Nickel plating, and anodizing are offered for specialized corrosion protection and performance requirements.',
          'Zinc iron and zinc nickel plating provide enhanced resistance in demanding environments.',
          'Advanced coating systems such as Geomet, Dacromet, Magni, and zinc flake coatings ensure long-term protection.'
        ]
      },
      {
        title: 'Types of Surface Finishes',
        image: '/manufacturing/sf-3.png',
        content: [
          'These surface coatings improve the durability, corrosion resistance, and appearance of fasteners used in industrial applications.',
          'Processes like zinc plating, electroless nickel plating, and blackening create a protective barrier against rust and environmental wear.',
          'Coatings such as Dacromet, Geomet, and Delta Seal offer advanced protection in harsh conditions without significantly increasing thickness.',
          'Each coating type is selected based on performance needs, including strength retention, chemical resistance, and long-term reliability.'
        ]
      }
    ]
  },
  {
    id: 7,
    name: 'QUALITY CHECK',
    description: 'Rigorous dimensional, physical, and chemical testing against industry standards with full traceability and certification.',
    image: '/manufacturing/qc-1.jpg',
    pages: [
      {
        title: 'Dimensional Inspection and Physical Testing',
        image: '/manufacturing/qc-1.jpg',
        content: [
          'XPS ensures the highest standards of quality through comprehensive inspection and testing processes.',
          'XPS conducts rigorous quality assurance on all fasteners produced — dimensional, physical, and chemical testing against industry standards or customer-specific requirements.',
          'Every batch undergoes detailed dimensional inspection to ensure accuracy and compliance with specifications.',
          'Physical testing is carried out to verify strength, hardness, and overall performance.'
        ]
      },
      {
        title: 'Chemical Analysis and In-Process Inspection',
        image: '/manufacturing/qc-2.png',
        content: [
          'Chemical analysis ensures material composition meets required standards and specifications.',
          'Advanced testing equipment is used to deliver precise and reliable results.',
          'Our experienced quality team closely monitors every stage of production.',
          'In-process inspections help identify and eliminate defects at an early stage.'
        ]
      },
      {
        title: 'Final Inspection and Compliance Documentation',
        image: '/manufacturing/qc-3.png',
        content: [
          'Final inspection ensures that only fully compliant products are approved for dispatch.',
          'Dimensional Inspection Reports, Physical & Chemical Reports, and Certificates of Compliance are available on request.',
          'Complete documentation and traceability are maintained for all products.',
          'Quality checks at XPS guarantee consistency, reliability, and adherence to global standards.'
        ]
      }
    ]
  },
  {
    id: 8,
    name: 'PACKING & DISPATCH',
    description: 'High-quality packaging, accurate labelling, and reliable logistics partners for safe, timely delivery to customers worldwide.',
    image: '/manufacturing/pd-1.jpg',
    pages: [
      {
        title: 'Efficient Packing Solutions',
        image: '/manufacturing/pd-1.jpg',
        content: [
          'XPS ensures safe and efficient packing and dispatch of all finished fasteners.',
          'All finished fasteners are carefully packed to maintain product integrity, labelled as per customer specifications, and dispatched through reliable logistics partners to ensure timely and safe delivery to the end customer.',
          'High-quality packaging materials are used to prevent damage during handling and transit.',
          'Products are packed according to size, type, and customer requirements.'
        ]
      },
      {
        title: 'Packing Process Flow',
        image: '/manufacturing/pd-2.png',
        content: [
          'Proper labelling ensures easy identification, traceability, and compliance with customer standards.',
          'Customized packaging solutions are available based on specific client needs.',
          'Each package is checked for accuracy before dispatch.',
          'Efficient inventory and dispatch systems help streamline order fulfilment.'
        ]
      },
      {
        title: 'Documentation and Seamless Dispatches',
        image: '/manufacturing/pd-3.png',
        content: [
          'Coordination with trusted logistics partners ensures reliable transportation.',
          'Timely dispatch schedules are maintained to meet delivery commitments.',
          'Documentation and shipping details are accurately maintained for every order.',
          'Packing and dispatch at XPS guarantee safe delivery, product protection, and customer satisfaction.'
        ]
      }
    ]
  }
];
